import { React, useCallback } from 'react';
// import { returnReceipt, setReceiptPrintCopy } from '../../actions/checks';
import classes from './NavReceiptsOrders.module.css';
import {
  Button,
  Modal,
  Table,
  Accordion,
  InputGroup,
  FormControl,
  Container,
  Row,
  Col,
  Form,
  Stack
} from 'react-bootstrap';
import OrdersPurchaseIcon from '../../../../images/order-purchase.svg';
import Loader from '../../../../images/loader.gif';
import SearchIcon from '../../../../images/search-icon.svg';
// import SearchIcon from '../../../../images/search-icon.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useReceiptsOrdersList } from './hooks/useReceiptsOrdersList';
import { formatDate, formatMoney, formatWeight } from '../../../../helpers/dataFormatter';
// import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import DatePickerSelect from '../../../ui/DatePickerSelect';

const NavReceiptsOrders = (props) => {
  const {
    delay,
    getReceiptsOrders,
    selectReceiptOrder,
    modalShow,
    // receiptsOrdersData,
    filteredReceiptsList,
    showLoader,
    filterDateStart,
    filterDateEnd,
    docNumberSearch,
    setDocNumberSearch,
    setModalShow,
  } = useReceiptsOrdersList();

  // const debouncedSearch = useCallback(
  //   delay((value) => {
  //     setDocNumberSearch(value);
  //   }, 500),
  //   [] // Empty dependency array to ensure the function is created once
  // );
  console.log('rerender');
  console.log('rows_filteredReceiptsList', filteredReceiptsList);
  return (
    <div>
      <Button
        className={`me-md-2 ${classes.button}`}
        size='sm'
        onClick={(e) => {
          e.target.parentElement.focus();
          e.target.parentElement.blur();
          setModalShow(true)
        }}
      >
        <img className={classes.nav_icon} src={OrdersPurchaseIcon} alt='checklist' /> <div className={classes.icon_text}>Замовлення покупців</div>
      </Button>
      {modalShow && (
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size='xl'
          centered
          scrollable={true}
          onClick={(event) => {
            event.stopPropagation();
          }}
        // dialogClassName="modal-90w"
        // dialogClassName="customModal"
        >
          {showLoader === true && (
            <img
              className='position-absolute top-50 start-50 translate-middle'
              src={Loader}
              style={{ width: '100px' }}
              alt=''
            />
          )}
          <Modal.Header closeButton>
            <Modal.Title id='contained-modal-title-vcenter'>
              Замовлення покупців
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={classes.modal_body}>
            <Container>
              <Row key="filter-row">
                <Col key="date-start" style={{ paddingTop: '3px' }} xs={6} md={2}>
                  <DatePickerSelect
                    dateValue={filterDateStart}
                    onChange={(date) => {
                      getReceiptsOrders(date, filterDateEnd);
                    }}
                  />
                </Col>
                <Col key="date-end" style={{ paddingTop: '3px' }} xs={6} md={2}>
                  <DatePickerSelect
                    dateValue={filterDateEnd}
                    onChange={(date) => {
                      getReceiptsOrders(filterDateStart, date);
                    }}
                  />
                </Col>
                <Col key="search" style={{ paddingTop: '3px' }} xs={6} md={2}>
                  <InputGroup style={{ width: '171px', height: '42px' }}>
                    <FormControl
                      placeholder='№'
                      aria-describedby='checklist-search-btn'
                      value={docNumberSearch}
                      onChange={(event) => { setDocNumberSearch(event.target.value) }} //debouncedSearch(event.target.value)}
                    // style={{}}
                    />
                    <Button
                      id='checklist-search-btn'
                      variant='outline-secondary'
                    >
                      <img
                        className={classes.search_icon}
                        src={SearchIcon}
                        alt='search'
                      />
                    </Button>
                  </InputGroup>
                </Col>
              </Row>
            </Container>
            <Accordion className='mt-1' flush>
              {filteredReceiptsList &&
                filteredReceiptsList.length > 0 &&
                filteredReceiptsList.map((item) => {
                  return (
                    <Accordion.Item eventKey={'history-' + item.id} key={'history-' + item.id}>
                      <Accordion.Header className={classes.header} as='div'>
                        {`№${item.webOrderId} (${Number(item.docNumber.toString().substring(3))}) від  ${formatDate(item.date)}, ${formatMoney(item?.sumTotal ?? 0)}₴, ${item?.phone ?? ''}, ${item?.fullName ?? ''}`}
                      </Accordion.Header>
                      <Accordion.Body className='p-0'>
                        <Table className={classes.table} size='sm'>
                          <thead>
                            <tr key={item.fiscalNumber}>
                              <th className='col-6'>Назва</th>
                              <th>К-сть</th>
                              <th>Ціна</th>
                              <th>Сума</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item?.products && item.products.map(
                              (checkProductItem) => {
                                return (
                                  <tr key={`${item.fiscalNumber}_${checkProductItem.id}`}>
                                    <td className={classes.td}>
                                      {checkProductItem.name}
                                    </td>
                                    <td className={classes.td}>
                                      {formatWeight(checkProductItem.count)}
                                    </td>
                                    <td className={classes.td}>
                                      {formatMoney(checkProductItem.price)}
                                    </td>
                                    <td className={classes.price}>
                                      {formatMoney(checkProductItem.sum)} грн
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </Table>
                        {item?.receiptSfr &&
                          <Table className={classes.table} size='sm'>
                            <thead>
                              <tr key={item.fiscalNumber}>
                                <th className='col-6'>Назва (ПРРО)</th>
                                <th>К-сть</th>
                                <th>Ціна</th>
                                <th>Сума</th>
                              </tr>
                            </thead>
                            <tbody>
                              {item?.receiptSfr && item.receiptSfr.products.map(
                                (checkProductItem) => {
                                  return (
                                    <tr key={`${item.fiscalNumber}_${checkProductItem.id}`}>
                                      <td className={classes.td}>
                                        {checkProductItem.name}
                                      </td>
                                      <td className={classes.td}>
                                        {formatWeight(checkProductItem.count)}
                                      </td>
                                      <td className={classes.td}>
                                        {formatMoney(checkProductItem.price)}
                                      </td>
                                      <td className={classes.price}>
                                        {formatMoney(checkProductItem.sum)} грн
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </Table>

                        }
                        <Button
                          className='ms-2 mb-2'
                          size='sm'
                          variant='outline-secondary'
                          onClick={(event) => {
                            selectReceiptOrder(item.id);
                          }}
                        >
                          Вибрати
                        </Button>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
            </Accordion>
          </Modal.Body>
        </Modal>
      )
      }
    </div >
  );
};

export default NavReceiptsOrders;
